import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequest } from "@utils/http-util";
import { injectAxnAttributeLabelId } from "@utils/parameter-injector";
import { AxnAttributeLabel } from "@idw-types/data/reference-data/axn";

export const getAxnAttributeLabelRequest = async (
    axnAttributeLabelId: string
): Promise<{ data: AxnAttributeLabel, error: any }> => {
    const route = injectAxnAttributeLabelId(apiRoutes.axnadminCore.data.axnattributelabelWithId, axnAttributeLabelId);
    const { data, error } = await handleRequest(RequestTypes.GET, route);
    return { data, error };
};